import * as Constants from '@/lib/constants'

const dname = [
  '北',
  '北北東',
  '北東',
  '東北東',
  '東',
  '東南東',
  '南東',
  '南南東',
  '南',
  '南南西',
  '南西',
  '西南西',
  '西',
  '西北西',
  '北西',
  '北北西',
]
const eachdeg = 360.0 / dname.length

export default class Azimuth {
  static toCompassDirection(degree, lang = Constants.LANG_EN) {
    const index = Math.round(degree / eachdeg) % dname.length
    let value = dname[index]
    if (lang === Constants.LANG_JA) {
      return value
    }
    value = value.replace(/東/g, 'E')
    value = value.replace(/西/g, 'W')
    value = value.replace(/南/g, 'S')
    value = value.replace(/北/g, 'N')
    return value
  }
}
